import { Icons } from '@cast/design-system';

import { ACTIVITY_PATHS } from '@cast/console-constants';

import { SidebarItem } from '../_components/SidebarItem';
import { SidebarLayout } from '../_components/SidebarLayout';
import { SidebarOrgSection } from '../_components/SidebarOrgSection';

export const AuditLogSidebar = () => {
  return (
    <SidebarLayout
      title="Activity log"
      subtitle="Across all platform"
      icon={<Icons.SquareHalf size={20} weight="light" />}
    >
      <SidebarOrgSection>
        <SidebarItem title="Event Log" url={ACTIVITY_PATHS.activityEvents} />
        <SidebarItem
          title="Notifications"
          url={ACTIVITY_PATHS.activityNotifications}
        />
      </SidebarOrgSection>
    </SidebarLayout>
  );
};
